module.exports = __webpack_public_path__ + "img/icon_kehu_10.f0ff5bb4.png";